import Dialog from '@mui/material/Dialog'

import type { Entity } from '@models/Entity'

import type { Contactpersoon } from '../types/Contactpersoon'

import { Create } from './dialogs/Create'
import { Delete } from './dialogs/Delete'
import { Edit } from './dialogs/Edit'

export { ContactpersoonDialog }

type Props = {
  entity: Entity
  onClose: () => void
  contactpersoon?: Contactpersoon
  type?: 'create' | 'edit' | 'delete'
}

function ContactpersoonDialog({
  entity,
  type,
  onClose,
  contactpersoon,
}: Props) {
  if (!type) return null

  return (
    <Dialog open fullWidth maxWidth={'md'}>
      {type === 'create' && <Create entity={entity} onClose={onClose} />}
      {type === 'edit' && contactpersoon && (
        <Edit contactpersoon={contactpersoon} onClose={onClose} />
      )}
      {type === 'delete' && contactpersoon && (
        <Delete
          contactpersoon={contactpersoon}
          entity={entity}
          onClose={onClose}
        />
      )}
    </Dialog>
  )
}
